import React, { useEffect, useRef, useState } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { usePreferences } from "../../contexts/PreferencesContext";



const AtribuicoesRedacoes = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_atribuicoes, setLoadingatribuicoes] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [atribuicoes, setatribuicoes] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { demanda_id, demanda_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [atribuicao_id, setatribuicaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getatribuicoes = async (page, search) => {

    let response = await Request.Get(`faculdade/get_atribuicoes_redacoes/${demanda_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setatribuicoes(response.atribuicoes);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingatribuicoes(false);


    }
  };

  const Deleteatribuicao = async (atribuicao_id) => {

    let response = await Request.Delete(`faculdade/delete_atribuicao/${atribuicao_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getatribuicoes(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getatribuicoes(1, search_oficial);
  }, []);

  const pesquisarTimeout = useRef(null);
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">{t('title_assignments')} "{demanda_name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search placeholder={t('placeholder_search_author_subject')} ValueChange={(value) => {
              clearTimeout(pesquisarTimeout.current);
              setSearchOficial(value);

              pesquisarTimeout.current = setTimeout(() => {
                let page = { ...pagination };
                page.current_page = 1;
                setPagination(pagination);
                setLoadingatribuicoes(true);

                Getatribuicoes(1, value);

              }, 1000);
            }} />

                        <div style={{ display: 'flex' }}>
                        <Link to={{
                pathname: "/atribuicoes/register_redacoes/" + demanda_id
                // state: {
                //     course_id: id
                // }
              }} style={{ textDecoration: "none" }}>
                            <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t('action_add_edit_assignments')}</p></Button>
                        </Link>
                        </div>
                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll mb-0">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t('label_descriptive')}</th>
                                        <th>{t('label_name')}</th>
                                        <th>{t('label_email')}</th>
                                        {/* <th>Quantidade de questões</th> */}
                                        <th data-priority="3">{t('label_actions')}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_atribuicoes == false && atribuicoes.map((item, id) =>

                  <tr key={id}>
                                            <td><p>{item.descritivo}</p></td>
                                            <td>{item.professor.name}</td>
                                            <td>{item.professor.email}</td>

                                            {/* <td>{item.numero_questoes==null?'Não especificado':item.numero_questoes}</td> */}


                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td>
                                                <div className="actions-group">
                                                <Link to={`/atribuicoes/show/${item.id}`} onClick={(e) => e.stopPropagation()}>

                                                    <span
                          onClick={() => {

                          }}
                          className="inline-flex align-center jcc bg-warning icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t('title_assignments')}>

                                                        <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </Link>
                                                <Link to={"/atribuicoes/register_redacoes/" + demanda_id} onClick={(e) => e.stopPropagation()}>
                                                    <span
                          className="inline-flex align-center jcc bg-info icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                          data-toggle="tooltip"
                          title={t('action_add_edit_assignments')}>

                                                        <MdModeEdit color="white" size={17} />
                                                    </span>
                                                </Link>
                                                <span
                        onClick={(e) => {
                          setatribuicaoId(item.id);
                          setShowWarning(true);
                          e.stopPropagation();
                        }}
                        className="inline-flex align-center jcc bg-danger icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title={t('action_delete')}>

                                                    <MdDelete size={17} color="white" />
                                                </span>

                                                </div>
                                                </td>

                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_atribuicoes == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_atribuicoes == false && atribuicoes.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t('empty_no_assignments_found')} icon="✍️" />

                        </div>
                    </div>}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingatribuicoes(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getatribuicoes(value, search_oficial);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_atribuicao={this.get_atribuicao.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingatribuicoes(true);
            Deleteatribuicao(atribuicao_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_aedfe8f4")}


        </SweetAlert>


            </div>

        </div>);

};

export default AtribuicoesRedacoes;